import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { OperatingHours, defaultOperatingHours } from '@types';
import { TimepickerComponent } from '../timepicker/timepicker.component';


type DayKey =
  | 'monday'
  | 'tuesday'
  | 'wednesday'
  | 'thursday'
  | 'friday'
  | 'saturday'
  | 'sunday'
  | 'publicHoliday';

@Component({
  standalone: true,
  imports: [CommonModule, MatSlideToggleModule, TimepickerComponent],
  templateUrl: './operating-hours.component.html',
  styleUrl: './operating-hours.component.scss',
  selector: 'app-operating-hours',
})
export class OperatingHoursComponent {
  @Input() operatingHours: OperatingHours = defaultOperatingHours;
  @Output() operatingHoursChange = new EventEmitter<OperatingHours>();

  public readonly days: { key: DayKey; label: string }[] = [
    { key: 'monday', label: 'Monday' },
    { key: 'tuesday', label: 'Tuesday' },
    { key: 'wednesday', label: 'Wednesday' },
    { key: 'thursday', label: 'Thursday' },
    { key: 'friday', label: 'Friday' },
    { key: 'saturday', label: 'Saturday' },
    { key: 'sunday', label: 'Sunday' },
    { key: 'publicHoliday', label: 'Public Holiday' },
  ];

  public onToggleEnabled(key: DayKey, checked: boolean): void {
    if (!this.operatingHours[key]) return;

    const hours = this.cloneOperatingHours();
    hours[key].enabled = checked;
    this.operatingHoursChange.emit(hours);
  }

  public onChangeOpen(key: DayKey, value: string): void {
    if (!this.operatingHours[key]) return;

    const hours = this.cloneOperatingHours();
    hours[key].open = value;
    this.operatingHoursChange.emit(hours);
  }

  public onChangeClose(key: DayKey, value: string): void {
    if (!this.operatingHours[key]) return;

    const hours = this.cloneOperatingHours();
    hours[key].close = value;
    this.operatingHoursChange.emit(hours);
  }

  private cloneOperatingHours(): OperatingHours {
    return JSON.parse(JSON.stringify(this.operatingHours));
  }
}
